// removed by extract-text-webpack-plugin
module.exports = {"root":"settings_root_4myx92","patterns":"settings_patterns_9whpck","pattern":"settings_pattern_3bo8ui","selected":"settings_selected_1lcctu"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/settings/settings.scss
// module id = 589
// module chunks = 0